import React from 'react';
import { useTranslation } from 'react-i18next';
import { editContainerStyle, editInputStyle, saveButtonStyle } from './styles';

const EditMode = ({
  inputRef,
  newTitle,
  setNewTitle,
  handleEditHistory,
  historyId,
  setIsEditing,
  setOpen,
  onClose,
  currentTitle
}) => {
  const { t } = useTranslation();

  const handleSave = (e) => {
    e.stopPropagation();
    handleEditHistory(historyId, newTitle);
    setIsEditing(false);
    setOpen(false);
    onClose && onClose();
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSave(e);
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setNewTitle(currentTitle);
    }
  };

  return (
    <div style={editContainerStyle}>
      <input
        ref={inputRef}
        style={editInputStyle}
        value={newTitle}
        onChange={e => setNewTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        maxLength={50}
        onClick={e => e.stopPropagation()}
      />
      <button
        style={saveButtonStyle}
        onClick={handleSave}
        disabled={!newTitle.trim()}
      >
        {t('drawer.save')}
      </button>
    </div>
  );
};

export default EditMode; 